module.exports = __webpack_public_path__ + "img/schoole-poster.103afa15.png";